import React from "react";
import CustomLink from "./CostumLink";

export default function DropDown(props){
    return (
        <div>
            <CustomLink to="/bio" text="BIO" onClick={props.onClick} />
            <CustomLink to="/resume" text="RESUME" onClick={props.onClick} />
            <CustomLink to="/contact" text="CONTACT" onClick={props.onClick} />
        </div>
    )
}
